export default __webpack_public_path__ + "static/media/i077vp.ba7d3302.webp";